import { IconShoppingCartSimple, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import {
  CONNECTOR,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { messages } from '../messages'

type Props = {
  onEdit: () => void
  onRemove: () => void
  value: number
}

export function MinQuantityRule(props: Props) {
  const { $t } = useIntl()
  const { onEdit, onRemove, value } = props
  return (
    <Rule onClick={onEdit} connector={CONNECTOR.NONE}>
      <RuleIcon>
        <IconShoppingCartSimple />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.rule.minQuantity.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <Tag>{$t(messages.rule.minQuantity.items, { value })}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
